import { trackEvent } from '@grnhse/datacoral_tracker';
import window from 'global/window';

window.__trackEvent = trackEvent;
